export const retryPromise = ({
  maxRetries,
  retryDelay,
  check
}: {
  maxRetries: number
  retryDelay: number
  check: () => boolean
}) => {
  let retries = 0

  return new Promise((resolve, reject) => {
    const checkAndRetry = () => {
      if (check()) {
        resolve('success')
      } else {
        retries++
        if (retries < maxRetries) {
          setTimeout(() => checkAndRetry(), retryDelay)
        } else {
          reject(new Error('retryPromise: retry limit reached'))
        }
      }
    }

    checkAndRetry()
  })
}
